import { TemplatesTranslationRequestDto } from './templates-translation-request-dto.interface';

export interface TemplatesTranslationRequest {
    balanceTemplateId?: string;
    incomeTemplateId?: string;
    legalForm?: string;
    accountingBasis?: string;
    balanceGroups: TemplatesTranslationRequestDto[];
    balanceFlis: TemplatesTranslationRequestDto[];
    balanceSubtotals?: TemplatesTranslationRequestDto[];
    balanceSubflis?: TemplatesTranslationRequestDto[];
    balanceOfThatItems?: TemplatesTranslationRequestDto[];
    incomeGroups: TemplatesTranslationRequestDto[];
    incomeFlis: TemplatesTranslationRequestDto[];
    incomeSubtotals?: TemplatesTranslationRequestDto[];
    incomeSubflis?: TemplatesTranslationRequestDto[];
    incomeOfThatItems?: TemplatesTranslationRequestDto[];
    locale: string;
    targetLocales: string[];
}
